import React from 'react';
import apiFetch from '@wordpress/api-fetch';
import {css, keyframes} from '@emotion/css';
import * as lodash from 'lodash';
import * as dateFns from 'date-fns';
import {getTimeSectionAndMenuKind} from '../helper';
import Corner from '../signage/corner';

export default class CornerSignage extends React.Component {

    constructor(props) {
        super(props);
        const searchParams = new URLSearchParams(window.location.search);
        const signage_id = searchParams.get('signage_id');
        this.state = {
            cafeteria_base: {
                cafeteria_name: '',
                cafeteria_logo: '',
                cafeteria_tax: 'in_tax_price',
                cafeteria_open_saturday: true,
                cafeteria_open_sunday: true,
                cafeteria_time_section_1_from: '',
                cafeteria_time_section_1_to: '',
                cafeteria_time_section_2_from: '',
                cafeteria_time_section_2_to: '',
                cafeteria_time_section_3_from: '',
                cafeteria_time_section_3_to: '',
                cafeteria_time_section_4_from: '',
                cafeteria_time_section_4_to: '',
                cafeteria_time_section_1_smt_from: '',
                cafeteria_time_section_1_smt_to: '',
                cafeteria_time_section_2_smt_from: '',
                cafeteria_time_section_2_smt_to: '',
                cafeteria_time_section_3_smt_from: '',
                cafeteria_time_section_3_smt_to: '',
                cafeteria_time_section_4_smt_from: '',
                cafeteria_time_section_4_smt_to: '',
                cafeteria_corner_quantity: 1, // コーナー数
                cafeteria_signage_quantity: 1, // コーナーサイネージ数(基本設定画面から取得したもの)    
            },
            cafeteria_corner: {
                cafeteria_corner: Array(7).fill().map(() => Array(4).fill().map(() => (
                    [
                        {
                            layout: 1,
                            display_number_1: 1, // コーナー番号1
                            display_number_2: 1, // コーナー番号2
                            side_visibled: false,
                            side_image: '',
                            left_and_right: 'left',
                        }
                    ]
                ))),
                cafeteria_corner_detail: Array(7).fill().map(() => Array(4).fill().map(() => (
                    [
                        {
                            text_color: '#ffffff',
                            bg_color: '#000000',
                            alternative_image: '',
                        }
                    ]
                ))),
            },
            is_initialize: false,
            signage_id: signage_id && signage_id !== '' ? Number(signage_id) - 1 : 0,
            provide_date: dateFns.format(new Date(), 'yyyyMMdd'),
            time_section: '1',
            cafeteria_menu: [],
            stamp_group_5_timer: [],
        }
    }

    fetchCornerSignage = async () => {
        try {
            // 各種設定の取得
            const res = await apiFetch({
                path: '/wp-json/cafeteria_api/signage_setting'
            });
            // コーナー数、コーナーサイネージ数の初期値
            let cafeteria_corner_quantity = 1;
            let cafeteria_signage_quantity = 1;

            // 現在日時、提供年月日、メニュー種別の初期値
            let provide_date = dateFns.format(new Date(), 'yyyyMMdd');
            let time_section = '0';
            // 基本設定の取得及び設定
            if (res.cafeteria_info_base_setting) {
                if (res.cafeteria_info_base_setting.cafeteria_corner_quantity) {
                    cafeteria_corner_quantity = res.cafeteria_info_base_setting.cafeteria_corner_quantity;
                }
                if (res.cafeteria_info_base_setting.cafeteria_signage_quantity) {
                    cafeteria_signage_quantity = res.cafeteria_info_base_setting.cafeteria_signage_quantity;
                }
                const res_time_section = getTimeSectionAndMenuKind(
                    res.cafeteria_info_base_setting.cafeteria_time_section_1_from,
                    res.cafeteria_info_base_setting.cafeteria_time_section_1_to,
                    res.cafeteria_info_base_setting.cafeteria_time_section_2_from,
                    res.cafeteria_info_base_setting.cafeteria_time_section_2_to,
                    res.cafeteria_info_base_setting.cafeteria_time_section_3_from,
                    res.cafeteria_info_base_setting.cafeteria_time_section_3_to,
                    res.cafeteria_info_base_setting.cafeteria_time_section_4_from,
                    res.cafeteria_info_base_setting.cafeteria_time_section_4_to,
                );
                provide_date = res_time_section.provide_date;
                time_section = res_time_section.time_section;
                this.setState({
                    cafeteria_base: res.cafeteria_info_base_setting,
                    provide_date: provide_date,
                    time_section: time_section,
                });
            }
            // サイネージ設定の取得及び設定(文字色／背景色、コーナー代替画像は集合サイネージを参照)
            if (res.cafeteria_info_signage_setting) {
                this.setState({
                    text_color: res.cafeteria_info_signage_setting.cafeteria_corner.text_color,
                    bg_color: res.cafeteria_info_signage_setting.cafeteria_corner.bg_color,
                    alternative_image: res.cafeteria_info_signage_setting.cafeteria_corner.alternative_image,
                });
            }
            // コーナー設定の取得及び設定
            if (res.cafeteria_info_corner_setting) {
                this.setState({
                    layout: res.cafeteria_info_corner_setting.cafeteria_corner.layout,
                    display_number_1: res.cafeteria_info_corner_setting.cafeteria_corner.display_number_1,
                    display_number_2: res.cafeteria_info_corner_setting.cafeteria_corner.display_number_2,
                    side_visibled: res.cafeteria_info_corner_setting.cafeteria_corner.side_visibled,
                    side_image: res.cafeteria_info_corner_setting.cafeteria_corner.side_image,
                    left_and_right: res.cafeteria_info_corner_setting.cafeteria_corner.left_and_right,
                });
            }
            const cafeteria_menu_path = '/wp-json/wp/v2/cafeteria_menu?per_page=100&provide_date=' + provide_date + '&time_section=' + time_section + '&menu_kind=1';
            const menu = await apiFetch({
                path: cafeteria_menu_path
            });

            if (menu) {
                // タイマースタンプのタイマー設定
                if (menu.length > 0) {
                    for(let i = 0; i < menu.length; i++) {
                        // 取得前後で同じメニューがある、又は、新規に取得されたメニューの場合
                        const find_menu = this.state.cafeteria_menu.find((val) => {
                            return menu[i].id === val.id;
                        });
                        if (
                            (find_menu && menu[i].acf.stamp_group_5 !== find_menu.acf.stamp_group_5) ||
                            !find_menu
                        ) {
                            // 同じ post_id のタイマーが存在する場合は、すべて削除
                            this.setState((pre_state) => {
                                const filter_state = pre_state.stamp_group_5_timer.filter((val) => {
                                    if (val.id === menu[i].id) {
                                        clearInterval(val.interval_id);
                                        return false;
                                    }
                                    return true;
                                });
                                return {stamp_group_5_timer: filter_state};
                            });
                            // タイマーセット及び配列追加
                            switch (menu[i].acf.stamp_group_5) {
                                case 'c1':
                                case 'c3':
                                case 'c5':
                                    const interval_id = setInterval(this.updateStampTimer, 60000, menu[i].id);
                                    this.setState((pre_state) => {
                                        pre_state.stamp_group_5_timer.push({
                                            id: menu[i].id,
                                            interval_id: interval_id,
                                            stamp_group_5: menu[i].acf.stamp_group_5,
                                            count: Number(menu[i].acf.stamp_group_5.substr(1)),
                                        });
                                        return {stamp_group_5_timer: pre_state.stamp_group_5_timer};
                                    });
                                    break;
                            }
                        }
                    }
                }
                this.setState({
                    cafeteria_menu: menu,
                });
            }
            // サイネージ設定の取得及び設定
            if (res.cafeteria_info_corner_setting) {
                //  取得したコーナーサイネージ設定の数が、コーナーサイネージ数よりも少ない場合、不足分を補完
                if (res.cafeteria_info_corner_setting.cafeteria_corner[0][0].length < cafeteria_signage_quantity) {
                    const add_array_count = cafeteria_signage_quantity - res.cafeteria_info_corner_setting.cafeteria_corner[0][0].length;
                    for (let i = 0; i < 7; i++) {
                        for (let j = 0; j < 4; j++) {
                            for (let k = 0; k < add_array_count; k++) {
                                const values = {
                                    layout: 1,
                                    display_number_1: 1,
                                    display_number_2: 1,
                                    side_visibled: false,
                                    side_image: '',
                                    left_and_right: 'left',
                                };
                                res.cafeteria_info_corner_setting.cafeteria_corner[i][j].push(values);
                            }
                        }
                    }
                } else if (res.cafeteria_info_corner_setting.cafeteria_corner[0][0].length > cafeteria_signage_quantity) {
                    // 取得数に余剰がある場合、余剰分を削除
                    const del_array_count = res.cafeteria_info_corner_setting.cafeteria_corner[0][0].length - cafeteria_signage_quantity;
                    for (let i = 0; i < 7; i++) {
                        for (let j = 0; j < 4; j++) {
                            for (let k = 0; k < del_array_count; k++) {
                                res.cafeteria_info_corner_setting.cafeteria_corner[i][j].pop();
                            }        
                        }
                    }
                }
                // 取得したコーナー設定の数が、コーナー数よりも少ない場合、不足分を補完
                if (res.cafeteria_info_signage_setting.cafeteria_corner[0][0].length < cafeteria_corner_quantity) {
                    const add_array_count = cafeteria_corner_quantity - res.cafeteria_info_signage_setting.cafeteria_corner[0][0].length;
                    for (let i = 0; i < 7; i++) {
                        for (let j = 0; j < 4; j++) {
                            for (let k = 0; k < add_array_count; k++) {
                                const values = {
                                    text_color: '#ffffff',
                                    bg_color: '#000000',
                                    alternative_image: '',
                                };
                                res.cafeteria_info_signage_setting.cafeteria_corner[i][j].push(values);
                            }
                        }
                    }
                } else if (res.cafeteria_info_signage_setting.cafeteria_corner[0][0].length > cafeteria_corner_quantity) {
                    // 取得数に余剰がある場合、余剰分を削除
                    const del_array_count = res.cafeteria_info_signage_setting.cafeteria_corner[0][0].length - cafeteria_corner_quantity;
                    for (let i = 0; i < 7; i++) {
                        for (let j = 0; j < 4; j++) {
                            for (let k = 0; k < del_array_count; k++) {
                                res.cafeteria_info_signage_setting.cafeteria_corner[i][j].pop();
                            }        
                        }
                    }
                }
                this.setState({
                    cafeteria_corner: {
                        cafeteria_corner: res.cafeteria_info_corner_setting.cafeteria_corner,
                        cafeteria_corner_detail: res.cafeteria_info_signage_setting.cafeteria_corner,
                    },
                    is_initialize: true,
                });
            } else {
                const clone_corner = lodash.cloneDeep(this.state.cafeteria_corner.cafeteria_corner);
                const clone_corner_detail = lodash.cloneDeep(this.state.cafeteria_corner.cafeteria_corner_detail);
                for (let i = 0; i < 7; i++) {
                    for (let j = 0; j < 4; j++) {
                        for (let k = 0; k < cafeteria_signage_quantity; k++) {
                            if (clone_corner[i][j][k] === undefined) {
                                const values = {
                                    layout: 1,
                                    display_number_1: 1,
                                    display_number_2: 1,
                                    side_visibled: false,
                                    side_image: '',
                                    left_and_right: 'left',
                                };
                                clone_corner[i][j].push(values);
                            }
                        }
                        for (let k = 0; k < cafeteria_corner_quantity; k++) {
                            if (clone_corner_detail[i][j][k] === undefined) {
                                const values = {
                                    text_color: '#ffffff',
                                    bg_color: '#000000',
                                    alternative_image: '',
                                };
                                clone_corner_detail[i][j].push(values);
                            }
                        }
                    }
                }
                this.setState({
                    cafeteria_corner: {
                        cafeteria_corner: clone_corner,
                        cafeteria_corner_detail: clone_corner_detail,
                    },
                    is_initialize: true,
                });
            }
        } catch (e) {
            // なにかしらエラーが発生した場合も、継続して更新を発生させるため、ログ出力のみで中断はしない
            console.log(e);
        }

        // 10秒間隔毎に更新する
        setTimeout(this.fetchCornerSignage, 10000);
    }

    // 残りn分スタンプのタイマー処理
    updateStampTimer = (id) => {
        this.setState((pre_state) => {
            let len = pre_state.stamp_group_5_timer.length;
            for (let i = 0; i < len; i++) {
                // post_id が一致するもののみ
                if (pre_state.stamp_group_5_timer[i].id === id) {
                    // 残り時間カウントを -1 分
                    pre_state.stamp_group_5_timer[i].count--;
                    // 残り時間に合わせ、表示するスタンプを変更。残り時間がない場合はタイマーを削除
                    if (pre_state.stamp_group_5_timer[i].count <= 0) {
                        pre_state.stamp_group_5_timer[i].stamp_group_5 = '0';
                        clearInterval(pre_state.stamp_group_5_timer[i].interval_id);
                    } else if (pre_state.stamp_group_5_timer[i].count <= 1) {
                        pre_state.stamp_group_5_timer[i].stamp_group_5 = 'c1';
                    } else if (pre_state.stamp_group_5_timer[i].count <= 3) {
                        pre_state.stamp_group_5_timer[i].stamp_group_5 = 'c3';
                    }
                }
            }
            // スタンプなし('0')となった配列は削除
            const filter_state = pre_state.stamp_group_5_timer.filter((val) => {
                return val.stamp_group_5 !== '0';
            });
            return {stamp_group_5_timer: filter_state};
        });
    };

    // コーナーサイネージ番号とコーナー番号により、メニュー画像URLを返す(集合サイネージとコーナーサイネージのコーナー番号は同じ)
    getCornerSignageImg = (week_num, time_section, signage_num, corner_num) => {
        // 指定されたsignage_numのデータを取得
        const signage_data = this.state.cafeteria_corner.cafeteria_corner[week_num][time_section][signage_num];
        if (!signage_data) {
            return [];
        }
    
        // コーナーに設定されたメニューがあるかチェック
        if (this.state.cafeteria_menu.length > 0) {
            const find_menu = this.state.cafeteria_menu.find((val) => {
                return val.acf.corner_number === String(corner_num);
            });
            if (find_menu) {
                return find_menu.img_urls.full;
            }
        }

        // メニューがない場合、コーナーの代替画像をセット
        if (this.state.cafeteria_corner.cafeteria_corner_detail[week_num][time_section][corner_num - 1]) {
            return this.state.cafeteria_corner.cafeteria_corner_detail[week_num][time_section][corner_num - 1].alternative_image;
        }

        // 代替画像もない場合、空値
        return '';
    };

    // コーナーサイネージ番号とコーナー番号により、コーナー名を返す(集合サイネージとコーナーサイネージのコーナー番号は同じ)
    getCornerSignageLabel = (week_num, time_section, signage_num, corner_num) => {
        // 指定された signage_num のデータを取得
        const signage_data = this.state.cafeteria_corner.cafeteria_corner[week_num][time_section][signage_num];
        if (!signage_data) {
            return [];
        }
    
        // コーナーに設定されたメニューがあるかチェック
        if (this.state.cafeteria_menu.length > 0) {
            const find_menu = this.state.cafeteria_menu.find((val) => {
                return val.acf.corner_number === String(corner_num);
            });
            if (find_menu) {
                if (find_menu.acf.corner_label === undefined || find_menu.acf.corner_label === null | find_menu.acf.corner_label === '') {
                    return String(find_menu.acf.corner_number);
                }
                return String(find_menu.acf.corner_label);
            }
        }
        return '';
    };

    // コーナーサイネージ番号とコーナー番号により、コーナー文字色／背景色を返す(集合サイネージとコーナーサイネージのコーナー番号は同じ)
    getCornerSignageColor = (week_num, time_section, signage_num, corner_num, text_or_bg) => {
         // 指定された signage_num のデータを取得
        const signage_data = this.state.cafeteria_corner.cafeteria_corner[week_num][time_section][signage_num];
        if (!signage_data) {
            return [];
        }
    
        // コーナーに設定された文字色／背景色があるかチェック
        if (this.state.cafeteria_corner.cafeteria_corner_detail[week_num][time_section].length >= corner_num) {
            if (text_or_bg === 'text_color') {
                return this.state.cafeteria_corner.cafeteria_corner_detail[week_num][time_section][corner_num - 1].text_color;
            } else {
                return this.state.cafeteria_corner.cafeteria_corner_detail[week_num][time_section][corner_num - 1].bg_color;
            }
        }

        // ない場合、初期値
        if (text_or_bg === 'text_color') {
            return '#ffffff';
        }
        return '#000000';
    };

    // コーナーサイネージ番号とコーナー番号により、メニューデータを返す(集合サイネージとコーナーサイネージのコーナー番号は同じ)
    getMenuData = (week_num, time_section, signage_num, corner_num) => {
        // 指定された signage_num のデータを取得
        const signage_data = this.state.cafeteria_corner.cafeteria_corner[week_num][time_section][signage_num];
        if (!signage_data) {
            return [];
        }

        // コーナーに設定されたメニューがあるかチェック
        if (this.state.cafeteria_menu.length > 0) {
            const find_menu = this.state.cafeteria_menu.find((val) => {
                return val.acf.corner_number === String(corner_num);
            });
            if (find_menu) {
                return find_menu.acf;
            }
        }
        return {};
    };

    // コーナーサイネージ番号とコーナー番号により、スタンプグループ５の現在の値を返す(集合サイネージとコーナーサイネージのコーナー番号は同じ)
    getStampGroup5 = (week_num, time_section, signage_num, corner_num) => {
        // 指定された signage_num のデータを取得
        const signage_data = this.state.cafeteria_corner.cafeteria_corner[week_num][time_section][signage_num];
        if (!signage_data) {
            return [];
        }

         // コーナーに設定されたメニューの現在のスタンプグループ５の値を返す
         if (this.state.cafeteria_menu.length > 0) {
            const find_menu = this.state.cafeteria_menu.find((val) => {
                return val.acf.corner_number === String(corner_num);
            });
            if (find_menu) {
                const find_timer = this.state.stamp_group_5_timer.find((val) => {
                    return val.id === find_menu.id;
                });
                if (find_timer) {
                    return find_timer.stamp_group_5;
                } else {
                    // あとn分以外のスタンプの場合、メニューに設定されたスタンプをそのまま返す
                    if (!/^c/.test(find_menu.acf.stamp_group_5)) {
                        return find_menu.acf.stamp_group_5;
                    }
                }
            }
        }
        return '0';
    };

    async componentDidMount() {
        // 初期処理
        this.fetchCornerSignage();
    }

    render() {
        const tab_week = dateFns.getDay(dateFns.parse(this.state.provide_date, 'yyyyMMdd', new Date()));
        const tab_time = (Number(this.state.time_section) - 1) < 0 ? 0 : Number(this.state.time_section) - 1;
        return (
            <React.Fragment>
                {
                    !this.state.is_initialize &&
                    <div>読み込み中...</div>
                }
                {
                    this.state.is_initialize &&
                    <div className="corner-layout">
                        <div className='corner-layout-top-nonscroll'>
                            {
                                this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].side_visibled &&
                                this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].left_and_right === 'left' &&
                                <div className="corner-layout-left">
                                    {
                                        this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].side_image &&
                                        this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].side_image !== '' &&
                                        <img src={this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].side_image} />
                                    }
                                    {
                                        (!this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].side_image ||
                                        this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].side_image === '') &&
                                        <img className="default-img" src={window.cafeteria_path.template_url + '/img/leftside.svg'} />
                                    }
                                </div>
                            }
                            <div className={this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].side_visibled ? 'corner-layout-menu' : 'corner-layout-menu-nonside'}>
                                {
                                    this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].layout === 1 &&
                                    <div className="corner-layout-1">
                                        <Corner
                                            className="corner-layout-1-1"
                                            imgUrl={this.getCornerSignageImg(tab_week, tab_time, this.state.signage_id, this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].display_number_1)} // 曜日-時間帯-集合サイネージID-コーナー番号1or2
                                            layout={this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].layout}
                                            sideVisibled={this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].side_visibled}
                                            cornerLabel={this.getCornerSignageLabel(tab_week, tab_time, this.state.signage_id, this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].display_number_1)}
                                            textColor={this.getCornerSignageColor(tab_week, tab_time, this.state.signage_id, this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].display_number_1, 'text_color')}
                                            bgColor={this.getCornerSignageColor(tab_week, tab_time, this.state.signage_id, this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].display_number_1, 'bg_color')}
                                            tax={this.state.cafeteria_base.cafeteria_tax}
                                            acf={this.getMenuData(tab_week, tab_time, this.state.signage_id, this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].display_number_1)}
                                            stampGroup5={this.getStampGroup5(tab_week, tab_time, this.state.signage_id, this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].display_number_1)}
                                        />
                                    </div>
                                }
                                {
                                    this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].layout === 2 &&
                                    <div className="corner-layout-2">
                                        <Corner
                                            className={"corner-layout-2-1"}
                                            imgUrl={this.getCornerSignageImg(tab_week, tab_time, this.state.signage_id, this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].display_number_1)}
                                            layout={this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].layout}
                                            sideVisibled={this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].side_visibled}
                                            cornerLabel={this.getCornerSignageLabel(tab_week, tab_time, this.state.signage_id, this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].display_number_1)}
                                            textColor={this.getCornerSignageColor(tab_week, tab_time, this.state.signage_id, this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].display_number_1, 'text_color')}
                                            bgColor={this.getCornerSignageColor(tab_week, tab_time, this.state.signage_id, this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].display_number_1, 'bg_color')}
                                            tax={this.state.cafeteria_base.cafeteria_tax}
                                            acf={this.getMenuData(tab_week, tab_time, this.state.signage_id, this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].display_number_1)}
                                            stampGroup5={this.getStampGroup5(tab_week, tab_time, this.state.signage_id, this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].display_number_1)}
                                        />
                                        <Corner
                                            className={"corner-layout-2-2"}
                                            imgUrl={this.getCornerSignageImg(tab_week, tab_time, this.state.signage_id, this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].display_number_2)}
                                            layout={this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].layout}
                                            sideVisibled={this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].side_visibled}
                                            cornerLabel={this.getCornerSignageLabel(tab_week, tab_time, this.state.signage_id, this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].display_number_2)}
                                            textColor={this.getCornerSignageColor(tab_week, tab_time, this.state.signage_id, this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].display_number_2, 'text_color')}
                                            bgColor={this.getCornerSignageColor(tab_week, tab_time, this.state.signage_id, this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].display_number_2, 'bg_color')}
                                            tax={this.state.cafeteria_base.cafeteria_tax}
                                            acf={this.getMenuData(tab_week, tab_time, this.state.signage_id, this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].display_number_2)}
                                            stampGroup5={this.getStampGroup5(tab_week, tab_time, this.state.signage_id, this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].display_number_2)}
                                        />
                                    </div>
                                }
                            </div>
                            {
                                this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].side_visibled &&
                                this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].left_and_right === 'right' &&
                                <div className="corner-layout-right">
                                    {
                                        this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].side_image &&
                                        this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].side_image !== '' &&
                                        <img src={this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].side_image} />
                                    }
                                    {
                                        (!this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].side_image ||
                                        this.state.cafeteria_corner.cafeteria_corner[tab_week][tab_time][this.state.signage_id].side_image === '') &&
                                        <img className="default-img" src={window.cafeteria_path.template_url + '/img/rightside.svg'} />
                                    }
                                </div>
                            }
                            
                        </div>
                    </div>
                }
            </React.Fragment>
        );
    }
}
